import React from 'react'

const RegistraionLink = ({link}) => (
  <div className="float">
    <a href={link} 
        className="btn-event-float"
        rel="noopener noreferrer"
        target="_blank">Register Now</a>
  </div>
)

export default RegistraionLink
